import { fileNameFormatter } from '../utils/fileNameFormatter';
import { PrintSpec } from '../types/cart';

export class OrderDocumentService {
  static async generateDocument(orderId: string, userName: string, specs: PrintSpec[]): Promise<File> {
    try {
      const orderNumber = orderId.split('-')[1];
      const date = new Date().toLocaleDateString('pt-BR');
      
      let markdown = `# Ordem de Serviço #${orderNumber}\n\n`;
      markdown += `**Cliente:** ${userName}\n`;
      markdown += `**Data:** ${date}\n\n`;
      
      specs.forEach((spec, index) => {
        markdown += `## Item ${index + 1} - ${spec.fileName}\n\n`;
        markdown += `**Especificações:**\n`;
        markdown += `- **Quantidade:** ${spec.quantity}\n`;
        markdown += `- **Tecnologia:** ${spec.technology}\n`;
        markdown += `- **Impressora:** ${spec.printer}\n`;
        markdown += `- **Material:** ${spec.material}\n`;
        markdown += `- **Cor:** ${spec.color}\n`;
        markdown += `- **Preenchimento:** ${spec.infill}\n`;
        markdown += `- **Qualidade:** ${spec.quality}\n`;
        
        if (spec.additionalService) {
          markdown += `- **Serviço Adicional:** ${spec.additionalService}\n`;
        }
        
        markdown += `- **Valor Unitário:** R$ ${(spec.price / spec.quantity).toFixed(2)}\n`;
        markdown += `- **Valor Total:** R$ ${spec.price.toFixed(2)}\n\n`;
      });

      return new File([markdown], `${orderId}.md`, { type: 'text/markdown' });
    } catch (error) {
      console.error('Erro na geração do documento:', error);
      throw error;
    }
  }
} 